import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-327" data-mp="upuiobiaxrsf">
      <div className="max-w-3xl mx-auto" data-id="element-328" data-mp="uojfodwoko2d">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-329" data-mp="zp7cjg7lbz4i">
          EL RESULTADO PARA VOS COMO DOCENTE
        </h2>

        <p className="text-xl mb-4 font-medium text-center" data-id="element-330" data-mp="14n8utyx6zuex">
          Con este material vas a lograr:
        </p>

        <div className="bg-green-50 rounded-2xl p-5 border border-green-200 mb-4" data-id="element-331" data-mp="7237xccetmt9">
          <ul className="space-y-2 text-xl font-bold text-gray-800" data-id="element-332" data-mp="c0efthj59n8u">
            <li className="flex items-start" data-id="element-333" data-mp="gy66y9byt5bz">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-334" data-mp="gx4rztrtvyoz" />
              <span data-id="element-335" data-mp="lq7reijae2d3">Ahorrar horas de planificación.</span>
            </li>
            <li className="flex items-start" data-id="element-336" data-mp="3kfy5y7oiqpjo">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-337" data-mp="3kf69yvr0epsv" />
              <span data-id="element-338" data-mp="3pd80u2uoftew">Tener los principales temas de ESI organizados.</span>
            </li>
            <li className="flex items-start" data-id="element-339" data-mp="y627cno6cwbw">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-340" data-mp="y8y448oadeyr" />
              <span data-id="element-341" data-mp="t8sipa8m0op4">Trabajar situaciones actuales con adolescentes.</span>
            </li>
            <li className="flex items-start" data-id="element-342" data-mp="ofpm0t8jcz4p">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-343" data-mp="jih2opbnip1v" />
              <span data-id="element-344" data-mp="jgd0cbtehy3p">Abordar temas sensibles con mayor seguridad.</span>
            </li>
            <li className="flex items-start" data-id="element-345" data-mp="fej5wl9stqbz">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-346" data-mp="ah9i1a225mq9" />
              <span data-id="element-347" data-mp="5i6aniylv4f4">Promover análisis, reflexión y pensamiento crítico.</span>
            </li>
          </ul>
        </div>

        <p className="text-2xl font-black text-center text-gray-900" data-id="element-348" data-mp="k4r6wx9p334">
          <span className="px-2 bg-[#FFFFFF]" data-id="element-349" data-mp="1zw7b289szzhb">
            Todo sin perder tiempo buscando actividades en internet.
          </span>
        </p>
      </div>
    </section>;
}